import Constants from '../../../app/utils/constants'
import technologbg from '../../../assets/images/technology/technologbg.svg'
import colors from '../../theme/color'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'

const TechnologySteps = () => {
  const { technologyStepsCards } = Constants
  const navigate = useNavigate()

  return (
    <section className="relative overflow-hidden px-2 py-14 md:py-20">
      <img
        src={technologbg}
        alt="technology steps background"
        className="opacity-20 absolute inset-0 h-full w-full object-contain"
      />

      <div
        className="absolute inset-0"
        style={{ backgroundColor: `${colors.deepNavy}D1` }}
      />

      <div className="relative z-10 mx-auto w-[92%] max-w-[1400px]">

        {/* 🔥 IMPORTANT: wrapper must have height */}
        <div className="relative">

          {/* ✅ FIXED LINE */}
          <motion.div
  className="pointer-events-none absolute left-1/2 top-0 hidden h-full w-[2px] -translate-x-1/2 origin-top md:block"
  style={{
    background: `linear-gradient(180deg, ${colors.industryHoverStart} 0%, ${colors.industryHoverEnd} 100%)`,
  }}
/>

<div className="relative space-y-8 md:space-y-10">

  {/* MOBILE FULL LINE */}
  <div
    className="absolute left-5 top-0 h-full w-[2px] md:hidden"
    style={{
      background: `linear-gradient(180deg, ${colors.industryHoverStart} 0%, ${colors.industryHoverEnd} 100%)`,
    }}
  />

  {/* TABLET/DESKTOP CENTER LINE */}
  <motion.div
    className="pointer-events-none absolute left-1/2 top-0 hidden h-full w-[2px] -translate-x-1/2 origin-top md:block"
    style={{
      background: `linear-gradient(180deg, ${colors.industryHoverStart} 0%, ${colors.industryHoverEnd} 100%)`,
    }}
  />

  {technologyStepsCards.map((step, index) => {
    const isLeft = index % 2 === 0

    return (
      <motion.div
        key={step.num}
        className={`relative flex w-full pl-12 md:pl-0 ${
          isLeft ? 'justify-start' : 'justify-start md:justify-end'
        }`}
        initial={{ opacity: 0, scale: 0.7, y: 60 }}
        whileInView={{ opacity: 1, scale: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{
          duration: 0.6,
          delay: index * 0.2,
          ease: 'easeOut',
        }}
      >

        {/* NUMBER */}
        <motion.div
          className="absolute left-5 top-18 z-20 h-12 w-12 -translate-x-1/2 rounded-full p-[1.5px] md:left-1/2 md:top-28 md:h-14 md:w-14"
          style={{
            background: `linear-gradient(120deg, ${colors.white}CC 0%, ${colors.technologyStepBadgeStart} 35%, ${colors.technologyStepBadgeEnd} 100%)`,
            boxShadow: `0 0 0 5px ${colors.technologyStepBadgeStart}29`,
          }}
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: false }}
          transition={{
            duration: 0.4,
            delay: index * 0.2,
          }}
        >
          <div
            className="flex h-full w-full items-center justify-center rounded-full text-sm font-semibold text-white md:text-base"
            style={{
              background: `linear-gradient(92.21deg, ${colors.technologyStepBadgeStart} 0%, ${colors.technologyStepBadgeEnd} 100%)`,
            }}
          >
            {step.num}
          </div>
        </motion.div>

        {/* CARD */}
        <motion.div
          className="w-full rounded-4xl p-px md:w-[calc(50%-1.25rem)]"
          style={{
            background: `linear-gradient(200.55deg, ${colors.technologyStepCardBorderStart} 0%, ${colors.technologyStepCardBorderEnd} 50.98%)`,
          }}
          whileHover={{ scale: 1.03 }}
          transition={{ type: 'spring', stiffness: 200 }}
        >
          <motion.article
            onClick={() => step.link && navigate(step.link)}
            className="relative h-full overflow-hidden rounded-4xl p-5 md:p-7 cursor-pointer"
            style={{ backgroundColor: colors.technology }}
          >

            {/* Glow left */}
            <span
              className="pointer-events-none absolute z-0 opacity-95 blur-3xl"
              style={{
                bottom: 0,
                left: 0,
                width: '60%',
                height: '70%',
                transform: 'translate(-4%, 10%)',
                background: `radial-gradient(
                  ellipse 95% 95% at 25% 80%,
                  ${colors.purpleAlt}50 42%,
                  transparent 10%
                )`,
              }}
            />

            {/* Glow right */}
            <span
              className="pointer-events-none absolute z-0 opacity-95 blur-3xl"
              style={{
                bottom: 0,
                right: 0,
                width: '25%',
                height: '55%',
                transform: 'translate(10%, 10%)',
                background: `radial-gradient(
                  ellipse 85% 75% at 75% 80%,
                  ${colors.industryHoverEnd}35 90%,
                  transparent 20%
                )`,
              }}
            />

            <div className="relative z-10">
              <h3 className="font-rajdhani text-2xl font-bold text-purple md:text-3xl xl:text-4xl 2xl:text-5xl">
                {step.heading}
              </h3>

              <ul className="font-gilroy mt-4 space-y-2 text-sm text-white/90 md:text-base xl:text-2xl 2xl:text-2xl">
                {step.points.map((point) => (
                  <li key={point}>• {point}</li>
                ))}
              </ul>
            </div>

          </motion.article>
        </motion.div>
      </motion.div>
    )
  })}
</div>

        </div>
      </div>
    </section>
  )
}

export default TechnologySteps